import GrandPrixNavbar from "../../components/GrandPrix/GrandPrixNavbar";
import { useParams } from "react-router-dom";
import ErrorPage from "../ErrorPage";
import GrandPrixRally from "../../components/GrandPrix/GrandPrixRally";

const Rally = () => {
  let { grandprix } = useParams();
  if (grandprix == null) return <ErrorPage />; //just in case gp name does not exist
  return (
    <div className="full-height padding-md app-container page-transition">
      <GrandPrixNavbar name={grandprix} active={12} />
      <GrandPrixRally grand_prix_name={grandprix} />
    </div>
  );
};

export default Rally;
